import React from "react";
import { Button } from "@/components/ui/button";

interface CourseHeaderProps {
  courseTitle: string;
  courseStatus: string;
  courseId: string;
  t: (key: string) => string;
}

export function CourseHeader({ courseTitle, courseStatus, courseId, t }: CourseHeaderProps) {
  return (
    <div className="mx-auto py-4 px-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight flex items-center">
            <span>{t('course-content.composer.title')}</span>
            <span className="ml-3 bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300 text-xs px-2 py-1 rounded-full">
              {courseStatus}
            </span>
          </h1>
        </div>
        <div className="flex items-center gap-2">
          <a href={`/lcms/course-content/${courseId}`}>
            <Button variant="outline">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="mr-2"
              >
                <line x1="19" y1="12" x2="5" y2="12"></line>
                <polyline points="12 19 5 12 12 5"></polyline>
              </svg>
              {t('course-content.composer.back')}
            </Button>
          </a>
          <a href={`/lcms/course-content/${courseId}/preview`} target="_blank" rel="noopener noreferrer">
            <Button variant="outline">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="mr-2"
              >
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              {t('course-content.composer.preview')}
            </Button>
          </a>
          <Button variant="outline">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="mr-2"
            >
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
              <polyline points="17 21 17 13 7 13 7 21"></polyline>
              <polyline points="7 3 7 8 15 8"></polyline>
            </svg>
            {t('course-content.composer.save')}
          </Button>
        </div>
      </div>
    </div>
  );
} 